module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"dpc headless portal","short_name":"dpc-portale","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon.jpg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"8e496d3229d3c6f98cd41173c7e6d963"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
